import i18next from 'i18next';

function translate(key) {
    return i18next.t(key) ? i18next.t(key) : key;
}

const OrderStatusSendPending = 2;
const OrderStatusOrdered = 4;
const OrderStatusInProduction = 5;
const OrderStatusPacked = 6;
const OrderStatusLoaded = 7;
const OrderStatusDelivered = 8;
const StatusDeliveredNonInvoicable = 9;

export function orderStatusToText(status) {
    switch (status) {
        case OrderStatusSendPending:
            return translate('order.sendPending');
        case OrderStatusOrdered:
            return translate('general.ordered');
        case OrderStatusInProduction:
            return translate('general.inProduction');
        case OrderStatusPacked:
            return translate('general.orderPacked');
        case OrderStatusLoaded:
            return translate('general.orderLoaded');
        case OrderStatusDelivered:
            return translate('general.delivered');
        case StatusDeliveredNonInvoicable:
            return translate('general.deliveredNonInvoicable');
        default:
            return '';
    }
}
